export const keys = {
  ll_server: "https://lovely-letters-prod.herokuapp.com",
  additional_headers: {},
};
